export const ApprovalAction_Approve = 324;
export const ApprovalAction_ApproveAndContinue = 325;
export const  ApprovalAction_Reject = 326;
export const  ApprovalAction_RejectAndContinue = 327;